import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { uniqueId } from 'lodash';

import './style.scss';
import { InputLabel } from '../InputLabel/component';
import { AutoSaveState } from '../AutoSaveIndicator/component';

declare interface CheckboxProps {
  className?: string;
  label: string | ReactNode;
  name: string;
  disabled?: boolean;
  checked?: boolean;
  children?: ReactNode;
  onChange: (checked: boolean) => void;
  description?: ReactNode;
  error?: string | null;
  required?: boolean;
  autoSave?: boolean;
  autoSaveState?: AutoSaveState;
}

export class Checkbox extends React.PureComponent<CheckboxProps> {
  private inputId: string;

  public constructor(props: CheckboxProps) {
    super(props);

    this.inputId = uniqueId();
  }

  private onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { onChange } = this.props;
    onChange(event.target.checked);
  };

  public render(): ReactNode {
    const {
      label,
      name,
      disabled = false,
      checked = false,
      children = null,
      className = null,
      description,
      error,
      required = false,
      autoSave = false,
      autoSaveState,
    } = this.props;
    return (
      <div className={classNames('ol-checkbox-input', className, { disabled })}>
        <div>
          <input
            type="checkbox"
            id={this.inputId}
            {...{ name, disabled, checked }}
            onChange={this.onChange}
          />
        </div>
        <div>
          <InputLabel
            htmlFor={this.inputId}
            error={error}
            required={required}
            autoSave={autoSave}
            autoSaveState={autoSaveState}
          >
            {label}
          </InputLabel>
          {description && (
            <span className="ol-checkbox-description">{description}</span>
          )}
          {children}
        </div>
      </div>
    );
  }
}
